module.exports = __webpack_public_path__ + "img/Frueher-768.8e7b0dd9.jpg";